import DisableUsersModal from './DisableUsersModal';

export default DisableUsersModal;